import store from '@/store';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import {Endpoints, Mutations} from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import ActionTarget from '@/ts/ActionTarget';
import {isEmpty} from 'lodash';

@Module({name: 'Recipients', namespaced: true})
export default class Recipients extends VuexModule {
    public recipientsVisible: boolean = false;
    public selectedRecipients: any = {projects: [], groups: [], units: []};
    public forWholeCorporation: boolean = false;
    public recipientRequired: boolean = false;
    public targetedRecipientsModalVisibility: boolean = false;
    public targetedRecipients: any = null;

    @Mutation
    public RESET_RECIPIENTS() {
        this.recipientsVisible   = false;
        this.selectedRecipients  = {projects: [], groups: [], units: []};
        this.forWholeCorporation = false;
        this.recipientRequired   = false;
        this.targetedRecipientsModalVisibility = false;
        this.targetedRecipients = null;
    }

    get getRecipientsVisible() {
        return this.recipientsVisible;
    }

    get getSelectedRecipients() {
        return this.selectedRecipients;
    }

    get getForWholeCorporation(): boolean {
        return this.forWholeCorporation;
    }

    get getRecipientRequired(): boolean {
        return this.recipientRequired;
    }

    get getSelectedRecipientsWithActionTargets() {
        const selectedRecipients     = cloneDeep(this.selectedRecipients);

        const actionTargetProjects   = store.getters['Projects/selectedProjects'];
        const actionTargetBuildings  = store.getters['Buildings/selectedBuildings'];
        const actionTargetProperties = store.getters['Properties/selectedProperties'];

        for (const project of actionTargetProjects) {
            if (!selectedRecipients.projects.some((recipient: any) => recipient.id === project.id)) {
                selectedRecipients.projects.push(project);
            }
        }

        for (const building of actionTargetBuildings) {
            if (!selectedRecipients.groups.some((recipient: any) => recipient.id === building.id)) {
                selectedRecipients.groups.push(building);
            }
        }

        for (const property of actionTargetProperties) {
            if (!selectedRecipients.units.some((recipient: any) => recipient.id === property.id)) {
                selectedRecipients.units.push(property);
            }
        }

        return selectedRecipients;
    }

    get getRecipientsIds() {
        const recipients =  cloneDeep(store.getters['Recipients/getSelectedRecipientsWithActionTargets']);

        const corporationIds = [store.getters['User/getUser'].corporationId];
        const projectIds     = recipients.projects.map((project: any) => project.id);
        const buildingIds    = recipients.groups.map((group: any) => group.id);
        const propertyIds    = recipients.units.map((unit: any) => unit.id);

        return {corporationIds, projectIds, buildingIds, propertyIds};
    }

    get getTargetedRecipients() {
        return this.targetedRecipients;
    }

    get isTargetedRecipientListModalVisible() {
        return this.targetedRecipientsModalVisibility;
    }

    @Mutation
    public SET_RECIPIENTS_VISIBILITY(visibility: boolean) {
        this.recipientsVisible = visibility;
    }

    @Mutation
    public SET_SELECTED_RECIPIENTS(data: any) {
        this.selectedRecipients = data;
    }

    @Mutation
    public SET_FOR_WHOLE_CORPORATION(status: any) {
        this.forWholeCorporation = status;
    }

    @Mutation
    public SET_RECIPIENT_REQUIRED(status: any) {
        this.recipientRequired = status;
    }

    @Mutation
    public RESET_RECIPIENT(type: any) {
        switch (type) {
            case 'projects':
                this.selectedRecipients.projects = [];
                break;

            case 'units':
                this.selectedRecipients.units = [];
                break;

            case 'groups':
                this.selectedRecipients.groups = [];
                break;
        }
    }

    @Mutation
    public SET_TARGETED_RECIPIENTS_MODAL_VISIBILITY(visibility: boolean) {
        this.targetedRecipientsModalVisibility = visibility;
    }

    @Mutation
    public SET_TARGETED_RECIPIENTS(data: any) {
        this.targetedRecipients = data;
    }

    @Action
    public FETCH_TARGETED_RECIPIENTS() {
        // The Notification VueX Module is used for the already created events/broadcasts
        // The Recipient VueX Module is used when the user is creating an event/broadcast
        const recipients = isEmpty(store.getters['Notifications/getNotificationRecipients']) ?
            store.getters['Recipients/getRecipientsIds'] : store.getters['Notifications/getNotificationRecipientIds'];

        // Remove the targeted corporationIds because it is useless
        recipients.corporationIds = [];

        axios.post(Endpoints.Admin.Notifications.GET_TARGETED_RECIPIENTS(), {
            targetedRecipients: recipients,
        })
            .then((response: any) => {
                store.commit(Mutations.SET_TARGETED_RECIPIENTS, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}

